<template>
  <!-- <section :ref="(el) => { wrapper = el; getRef(el)}" -->
  <section id="QBUXVZtdDHnBbwibb4V3aHGjudScUMWXc/aBCur+aYM=" class="video_area_bg pt-110 pb-100">
    <div class="container video_area">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Galeri Video TJSL
            </h4>
            <span
              class="wow fadeInUp mb-20"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <i style="color: black; font-size: smaller"
                >Informasi Galeri Video</i
              >
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div class="row">
        <!-- START FIRST VIDEO -->
        <div class="col-lg-8">
          <div class="row">
            <div
              v-if="firstVideo"
              class="mb-10 single_blog wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s">
              <div class="blog_content">
                <div class="zoom" style="position: relative">
                  <span class="label_video_orange">&nbsp;VIDEO&nbsp;</span>
                  <i
                    @click="showLightbox(firstVideo)"
                    id="play_video"
                    class="lni lni-play icon_play_video"
                    aria-hidden="true"
                    title="play"
                  ></i>
                  <img
                    style="
                      width: 100%;
                      position: relative
                    "
                    :src="
                    'https://img.youtube.com/vi/' +  firstVideo.code + '/maxresdefault.jpg'
                    "
                    @click="showLightbox(firstVideo)"
                  />
                  <div class="label_video_title col-sm-12">
                    <span @click="showLightbox(firstVideo)">{{ firstVideo.judul }}</span>
                    <p>
                      &nbsp;
                      <span><i class="lni lni-eye"></i>
                        {{ firstVideo.visitor_count }}
                      </span>
                      &nbsp;
                      &nbsp;
                      <i class="lni lni-calendar"></i>
                      &nbsp;{{ firstVideo.waktu_upload_yt }}&nbsp;
                    </p>
                  </div>
                </div>
                <!-- START VIDEO -->
                <!-- <div class="container-video">
                  <iframe
                    width="100%"
                    height="100%"
                    class="responsive-iframe"
                    :src="firstVideo.url"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                    type="text/html"
                    allowfullscreen
                  ></iframe>
                </div> -->
                <!-- END VIDEO -->
              </div>
            </div>
          </div>
        </div>
        <!-- END FIRST VIDEO -->
        <!-- START SIDE VIDEO -->
        <div class="col-lg-4 mb-25">
          <div
            class="mb-45 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.3s"
          >
            <!-- START SECOND VIDEO -->
            <div v-if="secondVideo" class="mb-15 zoom" style="position: relative">
              <span class="label_video_orange_small">&nbsp;VIDEO&nbsp;</span>
              <i
                @click="showLightbox(secondVideo)"
                id="play_video"
                class="lni lni-play icon_play_video_small"
                aria-hidden="true"
                title="play"
              ></i>
              <img
                style="
                  width: 100%;
                  position: relative;
                "
                :src="
                  'https://img.youtube.com/vi/' +  secondVideo.code + '/maxresdefault.jpg'
                "
                @click="showLightbox(secondVideo)"
              />
              <div class="label_video_title_small col-sm-12">
                <span @click="showLightbox(secondVideo)">{{ secondVideo.judul }}</span>
                <p>
                  &nbsp;
                  <span><i class="lni lni-eye"></i>
                    {{ secondVideo.visitor_count }}
                  </span>
                  &nbsp;
                  &nbsp;
                  <i class="lni lni-calendar"></i>
                  &nbsp;{{ secondVideo.waktu_upload_yt }}&nbsp;
                </p>
              </div>
            </div>
            <!-- END SECOND VIDEO -->
            <!-- START THIRD VIDEO -->
            <div v-if="thirdVideo" class="mb-15 zoom" style="position: relative">
              <span class="label_video_orange_small">&nbsp;VIDEO&nbsp;</span>
              <i
                @click="showLightbox(thirdVideo)"
                id="play_video"
                class="lni lni-play icon_play_video_small"
                aria-hidden="true"
                title="play"
              ></i>
              <img
                style="
                  width: 100%;
                  position: relative
                "
                :src="
                  'https://img.youtube.com/vi/' +  thirdVideo.code + '/maxresdefault.jpg'
                "
                @click="showLightbox(thirdVideo)"
              />
              <div class="label_video_title_small col-sm-12">
                <span @click="showLightbox(thirdVideo)">{{ thirdVideo.judul }}</span>
                <p>
                  &nbsp;
                  <span><i class="lni lni-eye"></i>
                    {{ thirdVideo.visitor_count }}
                  </span>
                  &nbsp;
                  &nbsp;
                  <i class="lni lni-calendar"></i>
                  &nbsp;{{ thirdVideo.waktu_upload_yt }}&nbsp;
                </p>
              </div>
            </div>
            <!-- END THIRD VIDEO -->
          </div>
        </div>
        <!-- END SIDE VIDEO -->
      </div>
      <div class="text-center">
        <router-link
              to="/_vid"
              @click="showVideo = true;"
              class="button-custom wow fadeInUp"
              style="display: block; margin: auto"
              data-wow-duration="2.0s"
              data-wow-delay="0.5s"
              >Lihat Galeri Video</router-link
            >
      </div>
      <!-- END CONTENT -->
    </div>
  </section>
  <!-- CUSTOM LIGHT BOX -->
    <div>
      <ModalVideos
        :url="url"
        :indeksFromParent="index"
        :visible="visible"
        :isi="isi"
        :pembuat="pembuat"
        :waktu_buat="waktu_buat"
        @clicked="closeLightbox"
      />
    </div>
    <!-- END CUSTOM LIGHT BOX -->
</template>

<script>
import VideoDataService from "../services/VideoDataService";
import axios from 'axios';
// import LightBox from "vue-it-bigger";
import ModalVideos from "./components/ModalVideos.vue";
// import { ref } from "vue";

export default {
  name: "video-list",
  emits:["openVideoChild"],
  components: {
    ModalVideos,
    // VueEasyLightbox,
  },
  props: {
    visibleVideo: Boolean,
  //   getRef: {
  //     type: Function,
  //   },
  // },
  // setup() {
  //   const wrapper1 = ref();
  //   return { wrapper1 };
  },
  data() {
    return {
      videos: [],
      firstVideo: "",
      secondVideo: "",
      thirdVideo: "",
      currentIndex: -1,
      title: "",
      isOrange: false,
      lastIndex: 0,
      index: 0,
      visible: false,
      isi: "", // untuk ModalVideos
      pembuat: "", // untuk ModalVideos
      waktu_buat: "", // untuk ModalVideos
      url: "", // untuk ModalVideos
    };
  },
  computed: {
    showVideo: {
      get() {
        return this.visibleVideo;
      },
      set(visibleVideo) {
        this.$emit("openVideoChild", visibleVideo);
      },
    },
  },
  methods: {
    // untuk ModalVideos
    showLightbox(data) {
      this.isi = data.isi;
      this.pembuat = data.pembuat;
      this.waktu_buat = data.waktu_buat;
      this.url = data.url;
      this.visible = true;
      this.index = 0;

      //insert visitor saat klik light box
      this.getUserAgent(data.id);
    },
    // untuk ModalVideos
    closeLightbox() {
      this.visible = false;
      this.index = 0;
      this.imagesLightBox = [];
    },
    // untuk ModalVideos
    prev(n) {
      this.index -= n;
    },
    // untuk ModalVideos
    next(n) {
      this.index += n;
    },

    retrieveVideos() {
      VideoDataService.getAll(0,3)
        .then((response) => {
          this.videos = response.data.data;
          this.firstVideo = this.videos[0];
          this.secondVideo = this.videos[1];
          this.thirdVideo = this.videos[2];
          // console.log(this.videos[1]);
          // console.log(this.secondVideo.url);
          this.currentIndex = 0;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    refreshList() {
      this.retrieveVideos();
      this.firstVideo = null;
      this.secondVideo = null;
      this.thirdVideo = null;
      this.currentIndex = -1;
    },

    getUserAgent(gv_id){
      axios
      .get("https://geolocation-db.com/json/")
      .then(response => {
        VideoDataService.sendUserAgent(
          gv_id, 
          'video',
          response.data.country_name,
          response.data.country_code,
          response.data.city,
          response.data.state,
          response.data.latitude,
          response.data.longitude,
          response.data.IPv4
        ).then((response) => {
          console.log(response.data);
          // this.currentArtikel = this.artikels[0];
          // this.currentIndex = 0;
        })
        .catch((e) => {
          console.log(e);
        });
        // this.products = response.data.products;
        // console.log(response.data.country_name);
      });
    }
  },
  mounted() {
    // var rect = this.wrapper1;
    // console.log(rect) // works fine!
    this.retrieveVideos();
  },
};
</script>

<style>
.zoom {
  transition: transform .2s; /* Animation */
}
.zoom:hover {
  transform: scale(1.04);
  cursor: pointer;
}

.label_video_orange {
  top: 10%;
  right: 0%;
  padding: auto;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #f06a25;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 15px;
}

.label_video_orange_small {
  top: 15%;
  right: -2%;
  padding: auto;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #f06a25;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 11px;
}

.label_video_title {
  bottom: 0%;
  position: absolute;
  background-color: #333333;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 20px;
}

.label_video_title_small {
  bottom: 0%;
  position: absolute;
  background-color: #333333;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 15px;
}

.label_video_title p {
  color: white;
  font-size: 10px;
}

.label_video_title_small p {
  color: white;
  font-size: 10px;
}

.single_blog .blog_content p {
    margin-top: 1px;
}

.icon_play_video {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #e7ebef;
  color: black;
  cursor: pointer;
  border-radius: 50px;
  box-shadow: 0px 0px 0px 0px black;
  padding: 2em 2em;
  z-index: 1;
}

.icon_play_video_small {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #e7ebef;
  color: black;
  cursor: pointer;
  border-radius: 50px;
  box-shadow: 0px 0px 0px 0px black;
  padding: 1em 1em;
  z-index: 1;
}

.container-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.container-subvideo {
  position: relative;
  overflow: hidden;
  width: 50%;
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 600px) {
  .label_video_orange {
    top: 15%;
    right: -2%;
    padding: auto;
    position: absolute;
    transform: translate(-50%, -50%);
    background-color: #f06a25;
    color: white;
    z-index: 1;
    padding-top: 0.3em;
    padding-bottom: 0.3em;
    padding-left: 1em;
    padding-right: 1em;
    font-size: 11px;
  }
  .icon_play_video {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    background-color: #e7ebef;
    color: black;
    cursor: pointer;
    border-radius: 50px;
    box-shadow: 0px 0px 0px 0px black;
    padding: 1em 1em;
    z-index: 1;
  }

  .label_video_title {
    font-size: 80%;
  }

  .label_video_title_small {
    font-size: 80%;
  }

  .single_blog .blog_content p {
    margin-top: 1px;
  }
}

@media screen and (max-width: 990px) {
  .iframe-custom {
    height: calc(40vh - 1px);
    width: 100%;
    box-sizing: border-box;
  }
}

@media screen and (min-width: 1200px) {
  .iframe-custom {
    height: calc(20vh - 2px);
    width: calc(24vw - 4px);
    box-sizing: border-box;
  }
}

@media screen and (min-width: 1400px) {
  .iframe-custom {
    height: calc(24vh - 5px);
    width: calc(24vw - 4px);
    box-sizing: border-box;
  }
}
</style>
